import { Component, EventEmitter, Input, HostListener, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MasterDataService } from 'src/app/services/master-data.service';
import { SpinnerService } from 'src/app/services/shared/spinner.service';

@Component({
  selector: 'app-lab-tests',
  templateUrl: './lab-tests.component.html',
  styleUrls: ['./lab-tests.component.scss']
})
export class LabTestsComponent implements OnInit {

  @Input() testsForm!: FormGroup;
  @Input() endCustomerData: any;

  @Output() onUpdate: EventEmitter<any> = new EventEmitter();

  labTests: any[] = [];
  filteredLabTests: any[] = [];
  testsData: any[] = [];

  showEditForm: boolean = false;
  copyLabTestsSetForm: any;

  noRecordsFoundData: boolean = false;
  isLabTestInputFieldClicked: boolean = false;
  isCheckBoxClicked: boolean = false;

  constructor(private masterDataService: MasterDataService, private spinnerService: SpinnerService) { }

  ngOnInit(): void {
    this.getLabTests();

    if (this.endCustomerData?.testsInfos?.length > 0) {
        const selectedTestIds = this.endCustomerData.testsInfos.map((info: any) => info.testsInfoId);
        this.testsForm.get('testsInfos')?.patchValue(selectedTestIds);
        this.getTestsData();
    }
}


  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
      const targetElement = event.target as HTMLElement;
      const dropdownElement = document.querySelector('.skillSetDopdownContainer');
      const formFieldElement = document.querySelector('.equipment');
  
      if (dropdownElement?.contains(targetElement) || formFieldElement?.contains(targetElement)) {
          return; 
      }
      
      this.isLabTestInputFieldClicked = false;
  }
  

  getLabTests() {
    this.spinnerService.showSpinner();

    this.masterDataService.getTests(0, 50, '').subscribe(data => {
      if (data?.data?.length > 0) {
        this.labTests = data.data;
        this.filteredLabTests = this.labTests;

        if (this.testsForm.get('testsInfos')?.value?.length > 0) {
          this.getTestsData();
        }
      }
      this.spinnerService.hideSpinner();
    }, error => {
      this.spinnerService.hideSpinner();
      console.error("Error fetching lab tests:", error);
    });
  }


  filterLabTests(event: any) {
    this.isLabTestInputFieldClicked = true;
    const searchText = event.target.value.toLowerCase();

    this.filteredLabTests = this.labTests.filter((test: any) =>
      test.name.toLowerCase().includes(searchText)
    );

    this.noRecordsFoundData = this.filteredLabTests.length === 0;
  }


  checkBoxClicked(labTests: any) {
    const labTestsControl = this.testsForm.get('testsInfos')?.value || [];

    if (labTestsControl.includes(labTests.id)) {
      const updatedTests = labTestsControl.filter((id: any) => id !== labTests.id);
      this.testsForm.get('testsInfos')?.patchValue(updatedTests);
    } else {
      labTestsControl.push(labTests.id);
      this.testsForm.get('testsInfos')?.patchValue(labTestsControl);
    }

  }


  labTestsInputFieldClicked() {
    this.isLabTestInputFieldClicked = true;
    if (this.filterLabTests.length === 0) {
      this.noRecordsFoundData = true;
    } else {
      this.noRecordsFoundData = false;
    }
  }


  keyDownButton(labtests: any, event: any) {
    if (event.key === 'Enter') {
      let labtestsControl = this.testsForm.get("testsInfos")?.value
      if (labtestsControl && labtestsControl.includes(labtests.id)) {
        labtestsControl = labtestsControl.filter((id: any) => id !== labtests?.id)
        this.testsForm.get("testsInfos")?.patchValue(labtestsControl);
      } else if (labtestsControl && !labtestsControl.includes(labtests.id)) {
        labtestsControl.push(labtests.id);
        this.testsForm.get("testsInfos")?.patchValue(labtestsControl);
      }
    }
  }

  update() {
    this.onUpdate.emit(10);
    this.refresh();
  }

  cancel() {
    this.showEditForm = false;
    this.testsForm.get('testsInfos')?.patchValue([]);

    if (this.copyLabTestsSetForm?.testsInfos?.length > 0) {
      this.testsForm.get('testsInfos')?.patchValue(this.copyLabTestsSetForm.testsInfos);
    }
    this.getTestsData();
  }

  editLabTests() {
    this.copyLabTestsSetForm = JSON.parse(JSON.stringify(this.testsForm.value));
    this.showEditForm = true;
  }

  refresh() {
    this.showEditForm = false;
    this.getTestsData();
  }

  getTestsData() {
    const tests = this.labTests;
    let testsInfos: any[] = [];

    if (this.endCustomerData?.testsInfos?.length > 0) {
      testsInfos = tests.filter((obj1: any) =>
        this.endCustomerData.testsInfos.some((obj2: any) => obj1.id === obj2.testsInfoId)
      );
    }
    this.testsData = testsInfos;
  }

  remove(i: number): void {
    this.testsForm.get('testsInfos')?.value.splice(i, 1);
    this.testsForm.get('testsInfos')?.patchValue(this.testsForm.get('testsInfos')?.value);
  }

  getLabTest(id: any) {
    return this.labTests.find((obj: any) => obj?.id === id)?.name;
  }

}